﻿import buttonLoader from '../utilities/buttonLoader.js';

var loginDialog = {};

loginDialog = {

  init: function () {
    var me = this;
    var loginForm = document.getElementsByClassName('loginDialog')[0];

    if (loginForm) {
        me.bind(loginForm);
    }

  },

  bind: function (form) {
      var me = this;

      form.addEventListener('submit', function (e) {

          e.preventDefault();

          var m = form.querySelector('.alert');

          if (m) {
              m.remove();
          }

          me.submit(form);

      });
  },

  submit: function (form) {
      var me = this;

      var button = form.querySelector('button[type=submit]');

      buttonLoader.start(button);

      var data = new FormData(form);

      var xhr = new XMLHttpRequest();
      xhr.open(form.getAttribute("method"), form.getAttribute("action"));

      xhr.onload = function () {

          var resp = JSON.parse(xhr.response);

          if (xhr.status >= 200 && xhr.status < 300) {

              if (resp.success) {

                  var dialogContainer = form.parentNode.parentNode;

                  dialogContainer.querySelector('.model__step--1').classList.remove('modal__step--current');
                  dialogContainer.querySelector('.model__step--2').classList.add('modal__step--current');

              } else {

                  buttonLoader.reset(button);

                  me.renderMessage(button, resp.message, 'error');
              }

          } else {

              buttonLoader.reset(button);

              me.renderMessage(button, 'Server error', 'error');
          }

      };

      xhr.send(data);
  },

  renderMessage: function (el, message, type) {
      el.insertAdjacentHTML('afterend', '<div class="alert ' + type + '">' + message + '</div>');

  }

};

loginDialog.initialize = function () {
    loginDialog.init();
};

module.exports = loginDialog;
